import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { PedidoPage } from '../pedido/pedido';
import { HttpProvider } from '../../providers/http/http';
import moment from 'moment';
import { DetallePage } from '../detalle/detalle';
/**
 * Generated class for the OrdenesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-ordenes',
  templateUrl: 'ordenes.html',
})
export class OrdenesPage {
  ordenes: any = []
  id: any = window.localStorage.getItem('id')
  carrito:any = []
  cant: any = 0
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http: HttpProvider,
    public events : Events
    ) {
    events.subscribe('carrito:update',()=>{
      this.contar()
      if(window.localStorage.getItem('carrito')){
        this.carrito = JSON.parse(window.localStorage.getItem('carrito'))
      }
    })
    if(window.localStorage.getItem('carrito')){
      this.carrito = JSON.parse(window.localStorage.getItem('carrito'))
      this.contar()
    }
    this.getOrdenes()
  }

  contar(){
    // let cant = 0
    // this.carrito.forEach(el=>{
    //   cant += parseFloat(el.cant)
    // })
    this.cant = (this.carrito && this.carrito.articulos && this.carrito.articulos.length > 0) ? this.carrito.articulos.length : 0
  }

  irCarrito(){
    this.navCtrl.push(PedidoPage)
  }

  format(item){
    return moment(item).format('DD-MM-YYYY')
  }

  getOrdenes(){
    this.http.get('orden/cliente/'+this.id).subscribe(
      (res:any)=>{
        this.ordenes = res
      },
      error=>console.log(error)
    )
  }

  reordenar(item){
    if(this.carrito.length>0){
      this.carrito.concat(item)
    }else{
      this.carrito = item
    }
    window.localStorage.setItem('carrito',JSON.stringify(this.carrito))
    this.navCtrl.push(PedidoPage)
  }

  ver(item){
    this.navCtrl.push(DetallePage,{orden:item})
  }

}



// WEBPACK FOOTER //
// ./src/pages/ordenes/ordenes.ts